import { Box, Flex, TextArea } from "@radix-ui/themes";
import { ArrowUpIcon } from "@radix-ui/react-icons";
import styles from "./AskAnythingChat.module.scss";
import { MultiDotsIcon } from "@/v2/assets/icons/MultiDotsIcon";

interface AskAnythingChatInputProps {
  input: string;
  isLoading: boolean;
  onSubmit: (event?: React.FormEvent) => void;
  onChange: (value: string) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

export function AskAnythingChatInput({
  input,
  isLoading,
  onSubmit,
  onChange,
  onKeyDown,
  disabled = false,
}: AskAnythingChatInputProps) {
  return (
    <Flex align="start" gap="3">
      <Flex direction="column" align="center" className={styles.inputIcon}>
        <Flex align="center" justify="center" className={styles.timelineIcon}>
          <MultiDotsIcon />
        </Flex>
      </Flex>
      <Box asChild flexGrow="1">
        <form onSubmit={onSubmit}>
          <div className={styles.inputWrapper}>
            <TextArea
              value={input}
              onChange={(event) => onChange(event.target.value)}
              onKeyDown={onKeyDown}
              placeholder="Ask anything..."
              disabled={isLoading || disabled}
              rows={3}
              className={styles.textarea}
              dir="auto"
            />
            <div className={styles.buttonRow}>
              <button
                type="submit"
                disabled={!input?.trim() || isLoading || disabled}
                className={styles.sendButton}
              >
                <ArrowUpIcon />
              </button>
            </div>
          </div>
        </form>
      </Box>
    </Flex>
  );
}
